import React from 'react';
import { ChevronRight, Dumbbell, Star, TrendingUp, Target } from 'lucide-react';

export default function FinalCTA({ lang }) {
  const t = {
    headline: lang === 'bg' ? 'РЕШИ СЕ СЕГА. ПОБЕДИ УТРЕ.' : 'DECIDE NOW. WIN TOMORROW.',
    sub:
      lang === 'bg'
        ? 'Присъедини се към общността от шампиони и надмини себе си'
        : 'Join the community of champions and beat your personal best',
    cta: lang === 'bg' ? 'СТАНИ ПРО' : 'GO PRO NOW',
    items: lang === 'bg'
      ? [
          { icon: Dumbbell, text: 'Тренировки от реални треньори' },
          { icon: Star, text: 'Специфични спортни протоколи' },
          { icon: TrendingUp, text: 'Проследяване на спортно представяне' },
          { icon: Target, text: 'Общност от шампиони' },
        ]
      : [
          { icon: Dumbbell, text: 'Workouts from real coaches' },
          { icon: Star, text: 'Sport-specific protocols' },
          { icon: TrendingUp, text: 'Athletic performance tracking' },
          { icon: Target, text: 'Community of champions' },
        ],
  };

  return (
    <section className="relative overflow-hidden">
      {/* Angled top */}
      <div
        className="absolute top-0 left-0 right-0 h-20 bg-[#0f172a]"
        style={{ clipPath: 'polygon(0 0, 100% 0, 100% 100%)' }}
      />

      <div
        className="relative pt-24 pb-20 md:pt-32 md:pb-28"
        style={{
          background: 'linear-gradient(135deg, #f97316 0%, #f59e0b 100%)',
        }}
      >
        {/* Background pattern */}
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'repeating-linear-gradient(45deg, #fff 0, #fff 1px, transparent 0, transparent 50%)',
              backgroundSize: '20px 20px',
            }}
          />
        </div>

        {/* Decorative shapes */}
        <div className="absolute -top-10 -left-10 w-64 h-64 rounded-full bg-white/10 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-10 -right-10 w-64 h-64 rounded-full bg-white/10 blur-3xl pointer-events-none" />

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-black uppercase text-4xl sm:text-6xl md:text-7xl lg:text-8xl text-white leading-none mb-4 drop-shadow-lg">
            {t.headline}
          </h2>

          <p className="text-white/80 text-base md:text-xl font-semibold mb-10">
            {t.sub}
          </p>

          {/* 4 pillars */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
            {t.items.map((item, i) => {
              const Icon = item.icon;
              return (
                <div
                  key={i}
                  className="bg-white/15 backdrop-blur-sm rounded-2xl p-4 md:p-5 border border-white/20 hover:bg-white/25 transition-all duration-200"
                >
                  <Icon className="w-6 h-6 text-white mx-auto mb-2" />
                  <div className="text-white font-bold text-sm md:text-base leading-tight text-center">
                    {item.text}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Big CTA button */}
          <a
            href="/s"
            className="group inline-flex items-center gap-3 px-10 md:px-14 py-5 md:py-6 rounded-full bg-white font-black text-base md:text-xl tracking-widest uppercase text-orange-600 shadow-2xl shadow-black/30 hover:scale-105 transition-all duration-300 hover:shadow-black/50"
          >
            {t.cta}
            <ChevronRight className="w-6 h-6 transition-transform group-hover:translate-x-1" />
          </a>

          <p className="mt-5 text-white/60 text-sm">
            {lang === 'bg' ? 'Ти срещу вчерашния ти. Всеки ден.' : 'You vs. Yesterday. Every single day.'}
          </p>
        </div>
      </div>

      {/* Angled bottom */}
      <div
        className="absolute bottom-0 left-0 right-0 h-20 bg-[#0f172a]"
        style={{ clipPath: 'polygon(0 100%, 100% 0, 100% 100%)' }}
      />
    </section>
  );
}
